<template>
  <div class="f-modal-header card-header border-bottom">
    <slot />
    <f-button theme="close" @click.prevent="away" />
  </div>
</template>
<script>

export default {
  name: 'f-modal-header',
  methods: {
    away() {
      this.$parent.$emit('close');
    }
  }
}
</script>

